import { createContext, useContext, useState } from "react";
import { MOCK_LOADS } from "@/data/mockLoads";

const LoadsContext = createContext(null);

export const LoadsProvider = ({ children }) => {
  const [loads, setLoads] = useState(MOCK_LOADS);

  const addLoad = (load) => {
    setLoads((prev) => [load, ...prev]);
  };

  return (
    <LoadsContext.Provider value={{ loads, addLoad }}>
      {children}
    </LoadsContext.Provider>
  );
};

export const useLoads = () => {
  const ctx = useContext(LoadsContext);
  if (!ctx) throw new Error("useLoads must be used within LoadsProvider");
  return ctx;
};
